import styled from 'styled-components';

import DecorativeImage from 'components/DecorativeImage';
import cardPaymentIllustration from 'features/Onboarding/images/cardPaymentIllustration.svg';

export const Illustration = styled(DecorativeImage).attrs({
  heightPx: 100,
  src: cardPaymentIllustration,
  widthPx: 160,
})`
  margin-bottom: ${({ theme }) => theme.spacings.abs48}px;
`;

export const CardExpiryDateWrapper = styled.div`
  flex: 1;
`;

export const CardCvcInputWrapper = styled.div`
  flex: 1;
  margin-left: ${({ theme }) => theme.spacings.abs24}px;
  max-width: 33%;
`;
